export default __webpack_public_path__ + "static/media/aeraBg.ba2d4bb6.jpg";